import { combineReducers } from 'redux';
import health from './health/health.slice';
import tenant from './tenant/tenant.slice';
import user from './user/user.slice';

export default combineReducers({
  user,
  health,
  tenant,
});
